import SummaryCard from 'components/SummaryCard';
import React from 'react';

// SAMPLE DATA
//     "user": {
//         "id": 9,
//         "first_name": "naveed",
//         "last_name": "ashraf",
//         "email": "naveed@12tech.com"
//  }

const UserInfoSummary = ({ props, description }) => {
  const data = [
    // { key: 'Name', value: `${props.first_name} ${props.last_name}` },
    { key: 'Email', value: props.email },
    { key: 'Id', value: props.id },
  ];

  return (
    <SummaryCard
      heading={`${props.first_name} ${props.last_name}`}
      data={data}
      description={description}
      icon={
        <i
          className="fa fa-user"
          aria-hidden="true"
          style={{ fontSize: '3rem' }}
        ></i>
      }
      mode="tooltip"
    />
  );
};

export default UserInfoSummary;
